import type { PageProps } from 'gatsby';
import * as React from 'react';
import Firmware from '../../components/Firmware';
import Layout from '../../components/Layout';
import { SeoDefault } from '../../components/Seo';

export default function PageFirmware(props: React.FC<PageProps>) {
  return (
    <Layout>
      <Firmware
        showFull={true}
        title='Noise Engineering Firmware'
        heading='Choose your next adventure'
        text='Click the Wizard button for a step-by-step guide or check out our handy video.'
        text2='Click on the Firmware dropdown to upload custom firmware.'
      />
    </Layout>
  );
}

export function Head() {
  return <SeoDefault />;
}
